export default __webpack_public_path__ + "static/ideta-single-d25409b9d9f7b8f8f980ae0dee8698a9.png";